import './App.css';
import React from 'react';
import Header from './pages/Header';
import Inicial from './pages/Inicial';
import Footer from './pages/Footer';
import Alerta from './components/Alerta';
import Loadergf from './components/Loadergf';
import 'react-notifications/lib/notifications.css';

function App() {
  
  return (
    <div className="App">
      <Alerta />
      <Header />
      <Loadergf />
      <Inicial  />
      <Footer />
    </div>
  );
}

export default App;
